module.exports = __webpack_public_path__ + "img/momo_index_bg.bfae2650.png";